import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

export const twitchConnected = (tracking: TrackingContextValue) =>
  GAEvent({ action: 'Twitch Connected' }, tracking);

export const twitchDisconnected = (tracking: TrackingContextValue) =>
  GAEvent({ action: 'Twitch Disconnected' }, tracking);
